import { useState } from 'react'
import toast from 'react-hot-toast'
import {fetchWithAuth} from '../../libs/apiUtils'
import Modal from '../Modal'

interface CreateMetadataModalProps {
  isOpen: boolean
  setIsOpen: (open: boolean) => void
  tableId: string
  onSuccess: () => void
}

export default function CreateMetadataModal({ 
  isOpen, 
  setIsOpen, 
  tableId,
  onSuccess 
}: CreateMetadataModalProps) {
  const [formData, setFormData] = useState({
    name: '',
    value: ''
  })
  const [loading, setLoading] = useState(false)

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target
    setFormData(prev => ({ ...prev, [name]: value }))
  }

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault()
    if (!formData.name.trim() || !formData.value.trim()) {
      return toast.error('Metadata name and value cannot be empty')
    }

    try {
      setLoading(true)
      const res = await fetchWithAuth(`${process.env.REACT_APP_BACKEND_URL}/api/table-metadata`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ...formData, tableId }),
      })

      const data = await res.json()

      if (!res.ok || !data.success) {
        toast.error(data[0].message || 'Error creating metadata')
        return
      }

      toast.success('Metadata created successfully')
      setFormData({ name: '', value: '' })
      setIsOpen(false)
      onSuccess()
    } catch (err) {
      toast.error('Network error, check your connection')
    } finally {
      setLoading(false)
    }
  }

  return (
    <Modal isOpen={isOpen} onClose={() => setIsOpen(false)}>
      <h3 className="text-xl font-bold text-neutral-800 mb-4">Tambah Metadata Baru</h3>
      <form onSubmit={handleSubmit}>
        <div className="mb-4">
          <label htmlFor="name" className="block text-sm font-semibold text-neutral-600 mb-2">
            Nama Metadata
          </label>
          <input
            type="text"
            id="name"
            name="name"
            className="border border-neutral-300 px-4 py-2 rounded-lg w-full focus:ring-2 focus:ring-primary-500 focus:border-primary-500 transition-all outline-none"
            value={formData.name}
            onChange={handleChange}
            placeholder="Contoh: Sumber Data"
            autoFocus
          />
        </div>

        <div className="mb-6">
          <label htmlFor="value" className="block text-sm font-semibold text-neutral-600 mb-2">
            Nilai Metadata
          </label>
          <input
            type="text"
            id="value"
            name="value"
            className="border border-neutral-300 px-4 py-2 rounded-lg w-full focus:ring-2 focus:ring-primary-500 focus:border-primary-500 transition-all outline-none"
            value={formData.value}
            onChange={handleChange}
            placeholder="Contoh: Dinas Pekerjaan Umum"
          />
        </div>

        <div className="flex justify-end gap-3">
          <button
            type="button"
            className="px-4 py-2 text-neutral-600 font-medium rounded-lg hover:bg-neutral-100 transition-colors"
            onClick={() => setIsOpen(false)}
            disabled={loading}
          >
            Batal
          </button>
          <button
            type="submit"
            className="bg-primary-600 text-white px-6 py-2 rounded-lg font-semibold hover:bg-primary-700 active:scale-95 disabled:opacity-50 disabled:active:scale-100 transition-all"
            disabled={loading}
          >
            {loading ? 'Menyimpan...' : 'Tambahkan Metadata'}
          </button>
        </div>
      </form>
    </Modal>
  )
}
